import { put, call, takeLatest, delay, select } from "redux-saga/effects";
import { settings } from "../../selectors";
import { ErrorHandler } from "../../utils/errorHandler";
import * as actions from "./actions";
import {
  getShifts,
  createShifts,
  updateShifts,
  unRegisterShift,
  get_cities,
  update_city,
  delete_city,
  update_town,
  delete_town,
  get_towns,
  add_town,
  add_city,
} from "./services";

const success_msg = "Changes Saved Successfully!";

function* __SHIFTS(action) {
  try {
    const res = yield getShifts();
    const data = res?.data;
    if (res.status === 200) {
      yield put(actions.setShiftsInCity(data.shifts));
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __CREATESHIFTS(action) {
  try {
    yield createShifts(action.payload);
    yield put(actions.getShiftsInCity());
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __UPDATESHIFTS(action) {
  try {
    yield updateShifts(action.payload);
    yield put(actions.getShiftsInCity());
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError(errorMessage));
  }
}

function* __UNREGISTERSHIFT(action) {
  try {
    yield unRegisterShift(action.payload);
    yield put(actions.getShiftsInCity());
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __ADDCITY(action) {
  try {
    const { region } = yield select(settings);
    yield add_city(action.payload);
    yield put(actions.get_cities({ regionId: region }));
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __GETCITIES(action) {
  try {
    const res = yield get_cities(action.payload);
    yield put(actions.set_cities(res.data?.result || []));
    yield put(actions.set_towns([]));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __UPDATECITY(action) {
  try {
    const { region } = yield select(settings);
    yield update_city(action.payload);
    yield put(actions.get_cities({ regionId: region }));
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __DELETECITY(action) {
  try {
    const { region } = yield select(settings);
    yield delete_city(action.payload);
    yield put(actions.get_cities({ regionId: region }));
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __ADDTOWN(action) {
  try {
    const { city } = yield select(settings);
    yield add_town(action.payload);
    yield put(actions.get_towns({ cityId: city }));
    yield put(actions.setSuccess(success_msg));
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __GETTOWNS(action) {
  try {
    const res = yield get_towns(action.payload);
    yield put(actions.set_towns(res.data?.result || []));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __UPDATETOWN(action) {
  try {
    const { city } = yield select(settings);
    yield update_town(action.payload);
    yield put(actions.get_towns({ cityId: city }));
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

function* __DELETETOWN(action) {
  try {
    const { city } = yield select(settings);
    yield delete_town(action.payload);
    yield put(actions.get_towns({ cityId: city }));
    yield put(actions.setSuccess(success_msg));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.setError({ error: errorMessage }));
  }
}

export function* get_shifts_in_city() {
  yield takeLatest(actions.GET_SHIFTS_IN_CITY, __SHIFTS);
}

export function* create_shifts_in_city() {
  yield takeLatest(actions.CREATE_SHIFTS_IN_CITY, __CREATESHIFTS);
}

export function* update_shifts_in_city() {
  yield takeLatest(actions.UPDATE_SHIFTS_IN_CITY, __UPDATESHIFTS);
}

export function* un_register_shift() {
  yield takeLatest(actions.UN_REGISTER_SHIFT, __UNREGISTERSHIFT);
}

export function* add_city_saga() {
  yield takeLatest(actions.ADD_CITY, __ADDCITY);
}

export function* get_cities_saga() {
  yield takeLatest(actions.GET_CITIES, __GETCITIES);
}

export function* update_city_saga() {
  yield takeLatest(actions.UPDATE_CITY, __UPDATECITY);
}

export function* delete_city_saga() {
  yield takeLatest(actions.DELETE_CITY, __DELETECITY);
}

export function* add_town_saga() {
  yield takeLatest(actions.ADD_TOWN, __ADDTOWN);
}

export function* get_towns_saga() {
  yield takeLatest(actions.GET_TOWNS, __GETTOWNS);
}

export function* update_town_saga() {
  yield takeLatest(actions.UPDATE_TOWN, __UPDATETOWN);
}

export function* delete_town_saga() {
  yield takeLatest(actions.DELETE_TOWN, __DELETETOWN);
}
